import { Record, List } from 'immutable'
import _ from 'lodash'

import {
    SETUP_GROUP_STACK,
    CHANGE_MEMBERS_PER_PAGE,
    SETUP_IMPORT_RESULTS_STATE,
    GROUP_STACK_NAME_BEING_EDITED,
} from './constants'

const InitialGroupData = Record({
    page: 0,
    pages: 1,
    rows: 10,
    members: List(),
    importResults: List(),
    loading: false,
    nameBeingEdited: false,
})

const InitialImportData = Record({
    importResults: List(),
    duplicated: 0,
    exists: 0,
    notFound: 0,
    ok: 0,
    total: 0,
    importing: false,
    imported: false,
})

const InitialGroupStackState = Record({
    activeGroup: null,
    membersPerPage: 0,
    groupData: new InitialGroupData(),
    importData: new InitialImportData(),
})

const InitialImportResult = Record({
    country: '',
    entId: '',
    name: '',
    reason: '',
    regNbr: '',
})

export default (groupStackState = new InitialGroupStackState(), action = {}) => {
    const { type } = action

    switch (type) {
        case SETUP_GROUP_STACK: {
            const groupId = _.get(action, 'data.groupId', null)
            const groupData = _.get(action, 'data.groupData', null)

            if (!groupId) {
                return groupStackState
                    .set('activeGroup', null)
                    .set('groupData', new InitialGroupData({ loading: true }))
            }

            return groupStackState
                .set('activeGroup', _.toString(groupId))
                .set('groupData', groupData ? new InitialGroupData(groupData) : groupStackState.groupData)
        }

        case CHANGE_MEMBERS_PER_PAGE: {
            const {
                data: { nextMembersCount },
            } = action
            const { membersPerPage } = groupStackState

            if (nextMembersCount !== membersPerPage) {
                return groupStackState.set('membersPerPage', nextMembersCount)
            }

            return groupStackState
        }

        case GROUP_STACK_NAME_BEING_EDITED: {
            const value = _.get(action, 'data.value', false)

            return groupStackState.setIn(['groupData', 'nameBeingEdited'], value)
        }

        case SETUP_IMPORT_RESULTS_STATE: {
            const {
                data: {
                    importResults,
                    importing,
                    results: { duplicated, exists, notFound, ok, total, imported },
                },
            } = action

            return groupStackState
                .setIn(
                    ['importData', 'importResults'],
                    List(importResults.map((result) => new InitialImportResult(result)))
                )
                .setIn(['importData', 'importing'], importing)
                .setIn(['importData', 'duplicated'], duplicated || 0)
                .setIn(['importData', 'exists'], exists || 0)
                .setIn(['importData', 'notFound'], notFound || 0)
                .setIn(['importData', 'ok'], ok || 0)
                .setIn(['importData', 'imported'], imported || false)
                .setIn(['importData', 'total'], total || 0)
        }

        default: {
            return groupStackState
        }
    }
}
